import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setVizLoading } from '../../../../store/visualizerSlice';
import ProductGroupStep from '../ProductGroupStep/ProductGroupStep';

export default function KitchenFaucets({
    surfaceName = 'Kitchen Faucet',
    stepIndex,
    room = '',
    onViewAllApplied,
    onNext,
    onPrevious
}) {
    const dispatch = useDispatch();

    const handleSelect = useCallback((product) => {
        const chamViz = document.getElementById('chamViz');
        if (!chamViz || !product.id) return;

        dispatch(setVizLoading(true));

        chamViz.applyByFilter(
            product.id,
            '',
            function(newSel) {
                if (this.name === 'Faucet') return newSel;
                return this.sel;
            },
            true
        );
    }, [dispatch]);

    return (
        <ProductGroupStep
            title="Kitchen Faucets"
            stepName="KitchenFaucets"
            seriesId="9786"
            surfaceName={surfaceName}
            stepIndex={stepIndex}
            room={room}
            onViewAllApplied={onViewAllApplied}
            onNext={onNext}
            onPrevious={onPrevious}
            onProductSelect={handleSelect}
        />
    );
}

KitchenFaucets.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
